export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_PERMISSION = 'GET_PERMISSION';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
